/**
 * The id of the element the Sentry feedback integration appends to `<body>` and
 * renders its dialog inside (as a shadow root).
 *
 * Stated rather than left to the SDK's default (`sentry-feedback`, @sentry/vue
 * 10.40) because `useFocusTrap` has to recognise the dialog by it: since #4694 the
 * feedback dialog opens *over* a Modal, SlideOutPanel or BottomSheet, and a key
 * pressed in it must not reach the trap of the overlay underneath.
 */
export const SENTRY_FEEDBACK_HOST_ID = 'sentry-feedback'
